import React from "react";
import PropTypes from "prop-types";

import { Flex } from "components/Layout";
import Button from "/components/Button";

import CartContext from "context/cart";

import styles from "./AddToBasket.module.scss";

const AddToBasket = ({ data }) => {
  const { price, title, id, image } = data || {};
  const cart = React.useContext(CartContext);

  const selectedAccessory = cart?.state?.accessories?.find((acc) => acc.id === id);

  const handlePlus = () => {
    cart.addAccessory({ title, price, id, image });
  };

  const handleMinus = () => {
    cart.removeAccessory(id);
  };

  const AddButton = () => {
    return (
      <Button primary type="button" onClick={handlePlus}>
        Legg til
      </Button>
    );
  };

  const Increment = () => {
    return (
      <>
        <button type="button" className={styles.increment} onClick={handleMinus}>
          -
        </button>
        <span className={styles.count}>
          <span>{selectedAccessory?.quantity}</span>
        </span>
        <button type="button" className={styles.increment} onClick={handlePlus}>
          +
        </button>
      </>
    );
  };

  return (
    <Flex>
      {!selectedAccessory && <AddButton />}
      {selectedAccessory?.quantity > 0 && <Increment />}
    </Flex>
  );
};

AddToBasket.propTypes = {
  data: PropTypes.object.isRequired
};

export default AddToBasket;
